import script from "./StandardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardHeader.vue?vue&type=script&setup=true&lang=js"

import "./StandardHeader.vue?vue&type=style&index=0&id=6e871e37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e871e37"]])

export default __exports__